module.exports = __webpack_public_path__ + "static/media/image73.d2b1a342.png";